import React, { Component, PureComponent } from 'react';
import { throttle, isEqual } from 'lodash';
import PropTypes from 'prop-types';
const getTopPosition = elem => elem.getBoundingClientRect().top + window.pageYOffset;
class ScrollSpyContext extends Component {
    static propTypes = {
        throttleRate: PropTypes.number,
        overwriteHash: PropTypes.bool,
        children: PropTypes.oneOfType([
            PropTypes.node,
            PropTypes.arrayOf(PropTypes.node),
        ]),
    };
    static defaultProps = {
        throttleRate: 16,
    };
    state = {
        items: [],
        selectedItems: [],
    };
    scrollEvent = null;
    componentDidMount() {
        const { throttleRate } = this.props;
        this.onScroll();
        this.scrollEvent = throttle(this.onScroll, 1000 / throttleRate, {
            trailing: true,
        });
        window.addEventListener('scroll', this.scrollEvent);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.scrollEvent);
    }
    onScroll = () => {
        const { overwriteHash } = this.props;
        const largestOffset = this.state.items.reduce((largestOffset, item) => {
            const elem = document.querySelector(item.selector);
            if (elem) {
                item.offsetTop = getTopPosition(elem) - item.offset - 1;
                return item.offsetTop > largestOffset &&
                    window.pageYOffset >= item.offsetTop
                    ? item.offsetTop
                    : largestOffset;
            }
            else {
                return largestOffset;
            }
        }, -Infinity);
        const selectedItems = this.state.items.filter(item => item.offsetTop === largestOffset);
        const selectedHref = selectedItems.length > 0 ? selectedItems[0].selector : '';
        if (!!overwriteHash &&
            !!selectedHref &&
            selectedHref !== window.location.hash) {
            history.pushState(null, null, selectedHref);
        }
        this.setState({
            selectedItems,
        });
    };
    shouldComponentUpdate(_nextProps, nextState) {
        const { selectedItems: nextSelectedItems } = nextState;
        const { selectedItems } = this.state;
        return !isEqual(selectedItems, nextSelectedItems);
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const children = nextProps.children;
        const items = React.Children.map(children, child => {
            if (child.type === ScrollSpy) {
                const { selector, offset } = child.props;
                return { selector, offset };
            }
        });
        return {
            ...prevState,
            items,
        };
    }
    render() {
        const children = this.props.children;
        const { selectedItems } = this.state;
        return React.Children.map(children, child => {
            if (child.type !== ScrollSpy) {
                return child;
            }
            const foundSelected = selectedItems.find(({ selector, offset }) => selector === child.props.selector && offset === child.props.offset);
            return React.cloneElement(child, {
                active: !!foundSelected,
            });
        });
    }
}
class ScrollSpy extends PureComponent {
    static propTypes = {
        offset: PropTypes.number,
        selector: PropTypes.string.isRequired,
        children: PropTypes.func.isRequired,
        active: PropTypes.bool,
    };
    static defaultProps = {
        offset: 70,
        active: false,
    };
    scrollToElement = () => {
        const { selector, offset } = this.props;
        const elem = window.document.querySelector(selector);
        if (elem) {
            window.scrollTo({
                top: getTopPosition(elem) - offset,
                behavior: 'smooth',
            });
        }
    };
    render() {
        const { children, active, ...rest } = this.props;
        return children({
            ...rest,
            active,
            scrollTo: this.scrollToElement,
        });
    }
}
ScrollSpy.Context = ScrollSpyContext;
export default ScrollSpy;
//# sourceMappingURL=index.js.map